import React from 'react';
import { graphql } from 'gatsby';

import Bulletins from '../components/Bulletins';
import Hero from '../components/Hero';
import Layout from '../components/Layout';
import Meta from '../components/Meta';

const IndexPage = ({ data }) => {
	return (
		<Layout invert>
			<Meta
				title={`EUROMOMO ${data.post.edges[0].node.frontmatter.title}`}
				description={data.post.edges[0].node.excerpt}
			/>
			<Hero></Hero>
			<Bulletins node={data.post.edges[0].node} list={data.list.edges.map((e) => e.node)} />
		</Layout>
	);
};

export default IndexPage;

export const query = graphql`
	query {
		list: allMarkdownRemark(
			sort: { fields: frontmatter___date, order: DESC }
			filter: { fileAbsolutePath: {}, frontmatter: { category: { eq: "bulletins" } } }
			limit: 10
		) {
			edges {
				node {
					frontmatter {
						title
						date
					}
					fields {
						slug
					}
				}
			}
		}
		post: allMarkdownRemark(
			sort: { fields: frontmatter___date, order: DESC }
			filter: { fileAbsolutePath: {}, frontmatter: { category: { eq: "bulletins" } } }
			limit: 1
		) {
			edges {
				node {
					frontmatter {
						title
						date
					}
					fields {
						slug
					}
					html
					excerpt
				}
			}
		}
	}
`;
